import { useApp } from '@tldraw/editor'
import { useCallback } from 'react'
import { useValue } from 'signia-react'
import { Button, Icon } from '../primitives'
import { Popover, PopoverContent, PopoverTrigger } from '../primitives/Popover'
import { StylePanel } from '../StylePanel'

export function MobileStylePanel() {
	const app = useApp()

	const currentColor = useValue(
		'current color',
		() => {
			const { props } = app
			return props ? (props.color ? app.getCssColor(props.color) : null) : 'var(--color-muted-1)'
		},
		[app]
	)

	const disableStylePanel = useValue(
		'isHandOrEraserToolActive',
		() => app.currentToolId === 'hand' || app.currentToolId === 'eraser',
		[app]
	)

	const handleStylesOpenChange = useCallback(
		(isOpen: boolean) => {
			if (!isOpen) {
				app.isChangingStyle = false
			}
		},
		[app]
	)

	return (
		<Popover id="style menu" onOpenChange={handleStylesOpenChange}>
			<PopoverTrigger disabled={disableStylePanel}>
				<Button
					className="tlui-toolbar__tools__button tlui-toolbar__styles__button tlui-popover__trigger"
					data-wd="mobile.styles"
					style={{ color: currentColor ?? 'var(--color-text)' }}
				>
					<Icon icon={currentColor ? 'blob' : 'mixed'} />
				</Button>
			</PopoverTrigger>
			<PopoverContent side="top" align="end">
				<StylePanel isMobile />
			</PopoverContent>
		</Popover>
	)
}
